import { Input as AntInput, Typography } from 'antd'
import styled from 'styled-components'

const { Text: AntText, Title: AntTitle } = Typography

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  width: 100%;
`

export const Title = styled(AntTitle)`
  color: ${({ theme }) => theme.colors.grey1} !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 24px !important;
  margin: 0 !important;
`

export const Content = styled.div`
  display: flex;
  flex: 1;
  gap: 24px;
`

export const ConsumptionColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 168px;
`

export const ConsumptionItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const ConsumptionMetric = styled.div`
  align-items: center;
  display: flex;
  gap: 10px;
`

export const ConsumptionInput = styled(AntInput)`
  height: 32px;
  text-align: center;
  width: 70px;
`

export const ConsumptionUnit = styled.span`
  color: ${({ theme }) => theme.colors.new.baseColor[400]};
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  white-space: nowrap;
`

export const EmissionsColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
`

export const EmissionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const MetricRow = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const MetricContainer = styled.div`
  width: 120px;
`

export const Label = styled(AntText)`
  color: ${({ theme }) => theme.colors.grey1} !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  white-space: nowrap;
`

export const ConsumptionLabel = styled(Label)`
  line-height: 18px;
`
